import React from 'react';
import PropTypes from 'prop-types';

import IOGrid from './IOGrid';

export default function IOEntrada({ data, onCallback, idposto }) {
  return (
    <IOGrid
      data={data}
      onCallback={onCallback}
      tipoIO="E"
      title="IO de Entrada"
      idposto={idposto}
    />
  );
}

IOEntrada.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onCallback: PropTypes.func.isRequired,
  idposto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IOEntrada.defaultProps = {
  data: [],
  idposto: null,
};
